import Grid from '@precis-digital/kurama/Grid'
import { styled } from '@precis-digital/kurama/utils'

interface HasDashboardFrameProps {
  hasDashboardFrame: boolean
}

export const StyledGridPageContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'hasDashboardFrame'
})<HasDashboardFrameProps>(({ hasDashboardFrame }) => ({
  height: hasDashboardFrame ? 'calc(100vh - 80px - 96px)' : '100vh',
  minHeight: hasDashboardFrame ? '100%' : '100vh',
  padding: hasDashboardFrame ? '0px 48px' : '48px 48px 24px 48px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  maxWidth: '1280px',
  margin: 'auto'
}))

export const StyledGridTopSectionContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'hasDashboardFrame'
})<HasDashboardFrameProps>(({ hasDashboardFrame }) => ({
  display: 'flex',
  gap: '24px',
  alignItems: 'center',
  height: `calc(100% - ${hasDashboardFrame ? '80px' : '108px'})`,
  position: 'relative'
}))

export const StyledGridRightSideContainer = styled(Grid)(() => ({
  width: '60%',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  button: {
    alignSelf: 'center'
  }
}))

export const StyledGridTextContainer = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  padding: '0px 48px',
  gap: '8px'
}))

export const StyledGridErrorCodeMessageContainer = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '4px'
}))

export const StyledGridButtonsContainer = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '16px'
}))
